import { useEffect, useState } from 'react';
import { api } from '../Api';

/**
 * Regime de avaliação da escola NAQUELE ano letivo ('BIMESTRAL' | 'TRIMESTRAL' | 'SEMESTRAL' | '').
 * Lê do 1º período cadastrado do ano (o regime pode mudar de um ano para outro);
 * se o ano não tiver período, usa o regime atual da escola.
 */
export async function buscarRegimeDoAno(idSchool, year) {
    if (!idSchool || !year) return '';
    try {
        // chamadas diretas (sem alert de erro): esta informação é só para o rótulo do período
        const q1 = await api.post('/index/istQuarter', { year, id_school: idSchool });
        const r = q1?.data?.data?.[0]?.assessmentRegime;
        if (r) return String(r).trim().toUpperCase();
    } catch { /* tenta o regime da escola */ }
    try {
        const r = await api.get(`/school/assessment-regime/${idSchool}`);
        return String(r?.data?.data || '').trim().toUpperCase();
    } catch {
        return '';
    }
}

export function useRegimeDoAno(idSchool, year) {
    const [regime, setRegime] = useState('');
    useEffect(() => {
        let ativo = true;
        setRegime('');
        buscarRegimeDoAno(idSchool, year).then((r) => { if (ativo) setRegime(r); });
        return () => { ativo = false; };
    }, [idSchool, year]);
    return regime;
}

// 'Bimestre' | 'Trimestre' | 'Semestre'
export const nomePeriodoDoRegime = (regime, curto = false) => {
    const r = String(regime || '').toUpperCase();
    if (r === 'TRIMESTRAL') return curto ? 'Trim' : 'Trimestre';
    if (r === 'SEMESTRAL') return curto ? 'Sem' : 'Semestre';
    return curto ? 'Bim' : 'Bimestre';
};
